import * as ROUTES from '../backend-routes'
import { executePost } from '../requests/axios'

export const fetchRegistrationTexts = function (payload, onSuccess, onError) {
  executePost(ROUTES.TOAS.PATH_REGISTRATION_TEXTS, payload, onSuccess, onError)
}

export const saveConsent = function (payload, onSuccess, onError) {
  executePost(ROUTES.TOAS.PATH_SAVE_LOGIN_CONSENT, payload, onSuccess, onError)
}
